import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledFilterButtonContainer = styled.div`
  ${() => `
    .active-layer {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 2;
        background: rgba(0, 0, 0, 0.2);
        &.hidden {
            display: none;
        }
    `}
`;

export const StyledFilterButtonWrapper = styled.div<any>`
  ${({theme, isDisabled}) => `
    display: none;
    @media screen and (min-width: ${Breakpoints.b960}px) {
        display: block;
        position: relative;
        width: auto;
        &.open {
            z-index: 2;
        }
        button {
            background: #FFFFFF;
            border: 1px solid #CCCCCC;
            border-radius: 100px;
            white-space: nowrap;
            font-family: ${
              theme.fonts.headline[200]?.fontFamily
            };
            font-style: normal;
            font-weight: 700;
            font-size: 14px;
            line-height: 36px;
            padding: 3px 5px;

            &:focus {
                outline: none;
                background: #FFFFFF;
                border: 1px solid #CCCCCC;
                border-radius: 100px;
            }

            &:hover {
                background: #FFFFFF;
            }

            ${
              isDisabled
                ? `
                color: #ABABAB;
                cursor: not-allowed;

                &:focus {
                    color: #ABABAB;
                }

                &:hover {
                    color: #ABABAB;
                    border: 1px solid #CCCCCC;
                    outline: none;
                }`: ''
            }
        }
    }
    @media screen and (min-width: ${Breakpoints.b1280}px) {
        button {
            padding: 3px 19px;
        }
    }
`}
`;

export const StyledFilterContentWrapper = styled.div`
  ${() => `
    z-index: 2;
    background: #ffffff;
    width: auto;
    display: flex;
    flex-direction: column;
    .apply-button {
        display: none;
    }
    @media screen and (min-width: ${Breakpoints.b960}px) and (max-width: 1459px){
        position: absolute;
        margin-top: 13px;
        left: 0;
        max-height: 50vh;
        overflow-y: auto;
        scroll-behavior: smooth;
        &.hidden {
            display: none;
        }
        .apply-button {
            display: flex;
            justify-content: flex-end;
            padding: 41px 33px 30px 0px;
        }
    }

    @media screen and (min-width: 1460px) {
        position: absolute;
        margin-top: 13px;
        right: 0;
        &.hidden {
            display: none;
        }
        .apply-button {
            display: flex;
            justify-content: flex-end;
            padding: 41px 33px 30px 0px;
        }
    }
`}
`;
